export default "__VITE_ASSET__DB_sg3nW__"